module.exports = __webpack_public_path__ + "img/check-gray.c99a71c6.svg";